/* eslint-disable prettier/prettier */
import React from 'react';
import { MONTHS_SHORT } from '../../utils/dateUtils';
import styles from '../../styles/scheduler/MonthPicker.module.css';

interface MonthPickerProps {
	selectedMonth: number;
	currentMonth: number;
	onSelectMonth: (month: number) => void;
}

const ROWS = [
	[0, 1, 2, 3],
	[4, 5, 6, 7],
	[8, 9, 10, 11],
];

const MonthPicker: React.FC<MonthPickerProps> = ({
	selectedMonth,
	currentMonth,
	onSelectMonth,
}) => (
	<div className={styles.picker}>
		<p className={styles.title}>Select Month</p>
		{ROWS.map((row, ri) => (
			<div key={ri} className={styles.row}>
				{row.map(m => (
					<button
						key={m}
						className={[
							styles.cell,
							m === selectedMonth ? styles.selected : '',
							m === currentMonth && m !== selectedMonth
								? styles.current
								: '',
						].join(' ')}
						onClick={() => onSelectMonth(m)}
					>
						{MONTHS_SHORT[m]}
					</button>
				))}
			</div>
		))}
	</div>
);

export default MonthPicker;
